import { getfile } from "@/entities/message";
import React, { useEffect, useRef, useState } from "react";
import { Button, Image, Form } from "react-bootstrap";
import { X } from "react-bootstrap-icons";

interface AvatarInputProps {
  avatarUrl: string | null;
  firstName: string | null;
  onAvatarChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onRemoveAvatar: () => void;
}

export const AvatarInput: React.FC<AvatarInputProps> = ({
  avatarUrl,
  firstName,
  onAvatarChange,
  onRemoveAvatar,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const [file, setFile] = useState(avatarUrl)

  useEffect(() => {
    if (avatarUrl) {
      getfile(avatarUrl)
        .then((data) => {
          const objectUrl = URL.createObjectURL(data);
          setFile(objectUrl);

          return () => {
            URL.revokeObjectURL(objectUrl);
          };
        })
        .catch((error) => {
          console.error("Error loading avatar:", error);
        });
    }
  }, [avatarUrl]);

  return (
    <Form.Group className="d-flex flex-column align-items-md-start align-items-center gap-3">
      <div
        style={{ position: "relative", width: 100, height: 100 }}>
        {file ? (
          <>
            <Image src={file} roundedCircle width={100} height={100} style={{ objectFit: "cover" }} />
            <Button
              variant="secondary"
              size="sm"
              onClick={onRemoveAvatar}
              type="button"
              style={{
                position: "absolute",
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                top: 7,
                right: 7,
                width: 16,
                height: 16,
                padding: 0,
                borderRadius: "50%",
              }}
            >
              <X size={14} />
            </Button>
          </>
        ) : (
          <div
            style={{
              width: 100,
              height: 100,
              borderRadius: "50%",
              backgroundColor: "#6c757d",
              color: "white",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontWeight: "bold",
              fontSize: 40,
            }}
          >
            {firstName?.[0]?.toUpperCase() || "?"}
          </div>
        )}
      </div>
      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={onAvatarChange}
      />
      <Button
        variant="outline-secondary"
        size="sm"
        type="button"
        onClick={() => fileInputRef.current?.click()}
      >
        Загрузить фото
      </Button>
    </Form.Group>
  );
};
